module.exports = __webpack_public_path__ + "img/code.74d86ab2.png";